var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear tarifa","subtitle":"Tarifa","back-to":"/tarifas"}}),_c('formulario',{attrs:{"tarifa":_vm.tarifa},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }